import { render, staticRenderFns } from "./CompanyChangeLogsDetailsView.vue?vue&type=template&id=23ae654b&scoped=true"
import script from "./CompanyChangeLogsDetailsView.vue?vue&type=script&lang=js"
export * from "./CompanyChangeLogsDetailsView.vue?vue&type=script&lang=js"
import style0 from "./CompanyChangeLogsDetailsView.vue?vue&type=style&index=0&id=23ae654b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ae654b",
  null
  
)

export default component.exports